module.exports = __webpack_public_path__ + "static/media/multiBar.c6e1bb43.svg";